import {
  Layer,
  Modal,
  // ComposedModal,
  ModalBody,
  // ModalFooter,
  // ModalHeader,
} from "@carbon/react";
// import ReactModal from "react-modal";

export const View = (props) => {
  const {
    isModalOpen,
    closeModal,

    children,
    modalHeader,
    modalFooter,
    className,
    fullscreen,
    selectorPrimaryFocus,
  } = props;

  return (
    // <ReactModal
    //   isOpen={isModalOpen}
    //   onRequestClose={closeModal}
    //   className={`${className} ${fullscreen ? "full-screen--modal" : ""}`}
    // >
    <Layer>
      <Modal
        open={isModalOpen}
        onRequestClose={closeModal}
        onClose={closeModal}
        // preventCloseOnClickOutside
        modalHeading={modalHeader}
        footer={modalFooter}
        passiveModal={modalFooter ? false : true} // remove modal footer
        className={`${modalHeader ? "with-header-border" : ""} ${className} ${
          fullscreen ? "full-screen--modal" : ""
        }`}
        selectorPrimaryFocus={selectorPrimaryFocus || ".submit-button"}
        selectorsFloatingMenus={[".cds--modal-content"]} // enable focus on inputs when modal is open on top of another modal: https://github.com/carbon-design-system/carbon/issues/12706
      >
        <ModalBody>{children}</ModalBody>
      </Modal>
    </Layer>
    // </ReactModal>
  );
};
